module.exports = __webpack_public_path__ + "assets/0f54a6079881de372f1eb64eb1f4ccbb.mp3";